import api from './api';

const batchService = {
  /** Get all active batches with daysRemaining, sorted by urgency */
  getActiveBatches: async (productId) => {
    const params = {};
    if (productId) params.productId = productId;
    const response = await api.get('/batches', { params });
    return response.data;
  },

  /** Get expired batches from audit table */
  getExpiredBatches: async (productId) => {
    const params = {};
    if (productId) params.productId = productId;
    const response = await api.get('/batches/expired', { params });
    return response.data;
  },

  /** Get loss analytics from expired batches */
  getLossAnalytics: async () => {
    const response = await api.get('/batches/loss-analytics');
    return response.data;
  },

  /** Get active + expired batches for a specific product */
  getBatchesByProduct: async (productId) => {
    const response = await api.get(`/batches/product/${productId}`);
    return response.data;
  },
};

export default batchService;